export const validatePostalCode = (pcInput: string): boolean => {
  const postalCode = pcInput.toString().trim()
  const ca = new RegExp(
    /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i
  )
  return ca.test(postalCode)
}
